import React from 'react';
import c from 'classnames';
import type Immutable from 'immutable';

import { Node } from '@uncinc/react-drupal-core';
import type { ImmutableEntity, NodeEntity } from '@uncinc/react-drupal-core/types';

interface ViewContentRelatedProps {
  entities: Immutable.List<ImmutableEntity<NodeEntity>>;
  viewClassName?: string;
  itemClassName?: string;
}

const ViewContentRelated: React.FC<ViewContentRelatedProps> = (props) => {
  const { entities, viewClassName, itemClassName } = props;

  const classes = c('ViewContentRelated', viewClassName);

  return (
    <div className={classes}>
      {entities.map((entity) => {
        const node = entity.toJS();
        const id = node.nid[0].value;
        const uuid = node.uuid[0].value;
        const langcode = node.langcode[0].value;
        const key = `${uuid}:${langcode}`;

        return (
          <div key={key} className={itemClassName}>
            <Node
              id={id}
              entity={entity}
              viewMode="teaser"
            />
          </div>
        );
      })}
    </div>
  );
};

export default ViewContentRelated;
